import React from "react"
import tw from "twin.macro"
import CLink from "../cLink"

const StoreItem = ({ number, store, onToggle, isSelected = false, t }) => {
  const toggleExpanded = () => {
    if (onToggle) {
      onToggle(store, !isSelected)
    }
  }

  return (
    <div css={[
      tw`relative overflow-hidden transition-all duration-200`,
      isSelected 
        ? tw`text-gris1` 
        : tw`text-marron3 hover:text-gris1`
    ]}>
      {/* Header de la tienda - siempre visible */}
      <div 
        css={tw`p-3 cursor-pointer transition-colors duration-200`}
        onClick={toggleExpanded}
      >
        <div css={tw`flex justify-between items-start`}>
          <div css={tw`flex-1`}>
            <div css={tw`flex items-center gap-2  text-obmed4 font-bold uppercase items-start`}>
              <div css={tw`w-7 text-right`}>
                {number}.
              </div>
              <div css={tw`flex-1`}>
                {store.title}
              </div>
              
            </div>
            {/* <p css={tw`text-gray-600 text-sm mb-2`}>
              {store.direccion || store.address}
            </p> */}
            {!isSelected && (<p css={tw`text-obsmall2 ml-7 pl-2`}>
              {store.localidad && (store.provincia.title !== store.localidad.title) && `${store.localidad.title} | `}
              {store.provincia && `${store.provincia.title}`}
            </p>)}
          </div>
          
          {/* Icono de expandir/contraer */}
          <div css={tw`ml-4 flex-shrink-0`}>
            <svg
              css={[
                tw`w-6 h-5 transition-transform duration-200`,
                isSelected && tw`transform rotate-180`
              ]}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </div>
        </div>
        {/* Contenido expandible */}
        {isSelected && (
          <div css={tw`ml-7 pt-2 pl-2 text-obsmall2`}>
            <p css={tw``}>
              {store.direccion}
              <br />
              {store.codigoPostal} {store.localidad && `${store.localidad.title} `}
              {store.provincia && (store.provincia.title !== store.localidad.title) && `(${store.provincia.title})`}
              {store.telefonoMovil && (
                <>
                <br />
                <strong>{store.telefonoMovil}</strong>
                </>
              )}
            </p>
            <CLink
              to={store.ruta}
              css={tw`inline-block my-3 p-2 text-center text-white text-obsmall2 md:text-obsmall2 font-bold uppercase bg-marron1 hover:bg-marron2`}
              >{t?.storeLocator?.masInfo}
            </CLink>
          </div>
        )}
      </div>

      
      <div css={tw`absolute bottom-0 left-3 right-3 h-px bg-marron3`} />
    </div>
  )
}

export default StoreItem 